/* Global imports. */
import React from "react";
import ContributorSpotlight from "@components/ContributorSpotlight";

interface Props {
  contributors: any;
  componentID?: string
}

const ContributorSpotlightCollection = ({ contributors, componentID }: Props) =>{
  return (
    <ol id={componentID} data-component="contributor-spotlight-collection" className="contributor-spotlight--list !ml-0 !list-none">
      {contributors.map((item:any) => <li>
        <ContributorSpotlight 
          contributorName={item.elements.name.value} 
          contributorId={item && item.elements && item.elements.contributor_id && item.elements.contributor_id.value}   
        />
      </li>
      )}
    </ol>
  )
} ;

export default ContributorSpotlightCollection;